import { SvgIcon, SvgIconProps } from '@mui/material'

const CheckListIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4697 4.46967C16.7626 4.17678 17.2374 4.17678 17.5303 4.46967L21.5303 8.46967C21.8232 8.76256 21.8232 9.23744 21.5303 9.53033C21.2374 9.82322 20.7626 9.82322 20.4697 9.53033L16.4697 5.53033C16.1768 5.23744 16.1768 4.76256 16.4697 4.46967Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5303 4.46967C21.8232 4.76256 21.8232 5.23744 21.5303 5.53033L17.5303 9.53033C17.2374 9.82322 16.7626 9.82322 16.4697 9.53033C16.1768 9.23744 16.1768 8.76256 16.4697 8.46967L20.4697 4.46967C20.7626 4.17678 21.2374 4.17678 21.5303 4.46967Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4939 14.4356C22.8056 14.7083 22.8372 15.1822 22.5644 15.4939L19.0644 19.4939C18.9277 19.6501 18.7324 19.7427 18.525 19.7496C18.3175 19.7565 18.1164 19.6771 17.9697 19.5303L15.9697 17.5303C15.6768 17.2374 15.6768 16.7626 15.9697 16.4697C16.2626 16.1768 16.7374 16.1768 17.0303 16.4697L18.4635 17.9028L21.4356 14.5061C21.7083 14.1944 22.1822 14.1628 22.4939 14.4356Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 5C1.25 4.58579 1.58579 4.25 2 4.25H13C13.4142 4.25 13.75 4.58579 13.75 5V9C13.75 9.41421 13.4142 9.75 13 9.75H2C1.58579 9.75 1.25 9.41421 1.25 9V5ZM2.75 5.75V8.25H12.25V5.75H2.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 15C1.25 14.5858 1.58579 14.25 2 14.25H13C13.4142 14.25 13.75 14.5858 13.75 15V19C13.75 19.4142 13.4142 19.75 13 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19V15ZM2.75 15.75V18.25H12.25V15.75H2.75Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default CheckListIcon
